<template>
	<div class="gameDetails">
		<!-- 游戏详情弹框 -->
		<el-dialog width="550px" :visible.sync="show" @open="openDetail()" :append-to-body="true" @close="close()" :close-on-click-modal="false"
			:close-on-press-escape="false" :show-close="false">
			<div class="home_dialog gamedal_dialog">
				<div class="home_dialog_title">
					Game Details
				</div>
				<div class="home_dialog_close">
					<img @click="close()" class="home_dialog_close_icon" src="../../../assets/icons/close_icon2.png"
						alt="" />
				</div>

				<div class="gamedal_dialog_info_box">
					<div @click="clickLike()" class="gamedal_dialog_like_icon_box">
						<img v-if="gameDetail.isCollect" class="gamedal_dialog_like_icon"
							src="../../../assets/icons/like_icon_h.png" alt="" />
						<img v-else class="gamedal_dialog_like_icon" src="../../../assets/icons/like_icon.png" alt="" />
					</div>

					<div class="gamedal_dialog_info_avatar_box">
						<img class="gamedal_dialog_info_avatar" :src="gameDetail.gameImage" alt="" />
					</div>
					<div class="gamedal_dialog_info">
						<div class="gamedal_dialog_info_title">
							{{gameDetail.gameName}}
						</div>
						<div class="gamedal_dialog_info_remark">
							Pragmatic Play
						</div>
						<div class="gamedal_dialog_info_rtp">
							RTP:{{gameDetail.gameLv}}%
						</div>
						<div class="gamedal_dialog_info_tag_box">
							<div class="gamedal_dialog_info_tag_item">
								{{gameDetail.gameTypeName}}
							</div>
						</div>
					</div>
				</div>
				<div @click="goPlayGame()" class="def_btn mar_t20 font_18">
					<img class="gamedal_dialog_play_icon" src="../../../assets/icons/play_icon.png" alt="" />
					Play
				</div>
				<div class="gamedal_dialog_price_remark">
					<img class="gamedal_dialog_chip_icon" src="../../../assets/icons/chip_icon.png" alt="" />
					Bonus cannot be wagered
				</div>

				<div class="gamedal_dialog_popular">
					<div class="gamedal_dialog_popular_top">
						<div class="gamedal_dialog_popular_title">
							<img class="gamedal_dialog_popular_icon" src="../../../assets/icons/popular_icon.png"
								alt="" />
							Popular
						</div>
						<div class="gamedal_dialog_popular_top_right">
							<div @click="clickGameAllShow(1)" class="gamedal_dialog_popular_more">
								MORE
							</div>
							<img @click="prevSlide(3)" class="gamedal_dialog_popular_right_icon"
								src="../../../assets/icons/home_left_icon.png" alt="" />
							<img @click="nextSlide(3)" class="gamedal_dialog_popular_right_icon"
								src="../../../assets/icons/home_right_icon.png" alt="" />
						</div>
					</div>

					<div class="gamedal_dialog_popular_list">
						<div class="swiper-wrapper" v-if="gameDetail.recommendGameList">
							<div class="swiper-slide gamedal_dialog_popular_item"
								v-for="game in gameDetail.recommendGameList" @click="clickGameDetali(game,1)">
								<img v-if="game.hotStatus" class="gamedal_dialog_hot_tag_icon2"
									src="../../../assets/icons/hot_tag_icon2.png" alt="" />
								<img class="gamedal_dialog_popular_item_avatar" :src="game.gameImage" alt="" />
								<div class="gamedal_dialog_popular_item_name">
									{{game.gameName}}
								</div>
							</div>
						</div>

					</div>

				</div>

			</div>
		</el-dialog>



		<!-- 全部游戏 -->
		<div v-if="gameAllShow">
			<favoritesPage :show="gameAllShow" title="Top Games" :url="''" @close="gameAllShow=false">
			</favoritesPage>
		</div>
		<!-- 进入游戏 -->
		<!-- <gamePage :gameUrl="gameUrl" v-if="gameUrl" @close="gameUrl=''"></gamePage> -->

	</div>
</template>

<script>
	import {
		mapState,
	} from 'vuex';

	import gamePage from './gamePage.vue'
	import favoritesPage from './favoritesPage.vue'
	export default {
		name: 'gameDetails',
		components: {
			favoritesPage,gamePage
		},
		computed: {
			...mapState(['user', 'token', 'selfType']), // 映射 user 模块下的 userInfo 状态
		},
		props: {
			show: {
				type: Boolean,
				default: false
			},
			item: {
				type: Object,
				default: {}
			},
		},
		data() {
			return {
				gameAllShow: false, //全部游戏列表
				gameDetail: {},
				gameShow:false,
				// gameUrl:''
			}
		},
		methods: {
			close() {
				this.$emit('close')
				// 进入游戏埋点--关闭
				this.$track.track('gameEnter',{
					amount:this.user.balance,
					gameId:this.item.gameId,
					type:'clone',
					userId:this.user.userId
				});
				this.$use.sendGoogleEvent('gameEnter')
			},
			goPlayGame() {
				// 首先检查 token 是否存在
				if (!this.token) {
					// 如果 token 不存在（未登录）
					this.$emit('close'); // 先关闭当前的游戏详情弹窗
					// 然后打开登录弹窗 
					this.$router.push({ path: 'login' }); 
					return; 
				}
				if (this.selfType.status == 1) {
					this.$store.dispatch('setSelfShow', true)
					return
				}
				//  window.location.href 生产环境 https://www.lky7bet.com/homePage  测试环境  https://www.lky7game.com/homePage
				this.$api.goPlayGame({
					id: this.item.gameId,
					platform: 'GPL_DESKTOP',
					lobbyUl: window.location.href
				}).then(res => {
					if (res.data.url) {
						this.$router.push({
							name: 'gamePage',
							query: {
								gameUrl:res.data.url
							}
						})
						this.$emit('close')
						// 进入游戏埋点--进入
						this.$track.track('gameEnter',{
							amount:this.user.balance,
							gameId:res.data.gameId,
							type:'enter',
							userId:this.user.userId
						});
						this.$use.sendGoogleEvent('gameEnter')
					} else {
						this.$use.msg('Failed to obtain game address', 'error')
					}
				})
			},
			openDetail() {
				this.clickGameDetali(this.item)
			},
			// 点击查看游戏详情
			clickGameDetali(row, type = 0) {
				this.gameDetail = {
					...row
				}
				this.$api.getGameDetails({
					id: row.gameId
				}).then(res => {
					this.gameDetail.recommendGameList = []
					this.gameDetail = res.data
					// if (type == 0) {
					this.initSwiper()
					// }
				})
			},
			// 点击收藏  取消收藏
			clickLike() {
				let apiName = ''
				let par = {}
				if (this.gameDetail.isCollect) {
					apiName = 'cancelGameCollect'
				} else {
					apiName = 'addGameCollect'
				}
				this.$api[apiName]({
					gameId: this.item.gameId
				}).then(res => {
					if(!this.gameDetail.isCollect){
						// 收藏游戏埋点
						this.$track.track('gameCollection',{
							amount:this.user.balance,
							gameId:this.item.gameId,
							userId:this.user.userId
						});
						this.$use.sendGoogleEvent('gameCollection')
					}
					this.gameDetail.isCollect = !this.gameDetail.isCollect
				})


			},
			// 初始化搜索游戏中的Swiper
			initSwiper() {
				// 确保 Swiper 在 el-dialog 打开后初始化
				this.$nextTick(() => {
					if (!this.detailsSwiper) {
						// 初始化 游戏详情弹框中的Swiper
						this.detailsSwiper = new window.Swiper(".gamedal_dialog_popular_list", {
							slidesPerView: 3,
							spaceBetween: 10,
							centeredSlides: true,
							loop: true,
						});
					} else {
						this.detailsSwiper.update(); // 如果 Swiper 已存在，更新它
					}
				});
			},
			// 上一张
			prevSlide(type) {
				if (this.detailsSwiper) {
					this.detailsSwiper.slidePrev(2); // 调用 Swiper 的 slideNext 方法
				}
			},
			// 下一张
			nextSlide(type) {
				if (this.detailsSwiper) {
					this.detailsSwiper.slideNext(2); // 调用 Swiper 的 slideNext 方法
				}
			},

			// 点击打开全部游戏弹框
			clickGameAllShow() {
				this.gameAllShow = true
				this.close()
			},








		},
	}
</script>

<style scoped>
	.gamedal_dialog {
		width: 100% !important;
		min-width: unset !important;
	}
	.gamedal_dialog_info_title {
		white-space: nowrap;
	}
	.gamedal_dialog_like_icon_box {
		top: 40px !important; /* 往下移动40px，可根据需要调整 */
	}
</style>